import { axios, API } from './config';

export const rentalsAPI = {
  getAll: async (category = null) => {
    const params = category ? { category } : {};
    const response = await axios.get(`${API}/rentals`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/rentals/${id}`);
    return response.data;
  },
  
  create: async (rentalData) => {
    const response = await axios.post(`${API}/rentals`, rentalData);
    return response.data;
  },
  
  update: async (id, rentalData) => {
    const response = await axios.put(`${API}/rentals/${id}`, rentalData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/rentals/${id}`);
    return response.data;
  }
};
